<template>
    <section class="case-results-container">
        <table-results-helper
            v-for="(employee, index) in sortedEmployees"
            :key="index"
            :title="'Cases: ' + employee.name + ' - ' + employee.staffId">
            <template v-slot:table>
                <table class="table table-striped table-sm table-hover">
                    <thead>
                        <tr>
                            <th scope="col">Case No.</th>
                            <th scope="col">Employee</th>
                            <th scope="col">Case Owner</th>
                            <th scope="col">Case Type</th>
                            <th scope="col">Topic</th>
                            <th scope="col">Status</th>
                            <th scope="col"
                                class="table-right">
                                <div class='custom-control custom-checkbox'>
                                    <input 
                                    type="checkbox" 
                                    class="custom-control-input" 
                                    :id="'caseSelect' + employee.id"
                                    :checked="isAllCasesSelected(employee.id)"
                                    @click="selectAllEmployeeCases($event, employee.id)">
                                    <label class="custom-control-label" :for="'caseSelect' + employee.id">Select All</label>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="caseResults && caseResults.length > 0 && employeeCases(employee.id).length > 0">
                            <tr
                                v-for="employeeCase in employeeCases(employee.id)"
                                :key="employeeCase.caseId">
                                <td>{{ employeeCase.caseId }}</td>
                                <td>{{ employeeCase.employeeName }}</td>
                                <td>{{ employeeCase.caseOwnerName }}</td>
                                <td>{{ employeeCase.primaryCaseType }}</td>
                                <td>{{ employeeCase.topicName }}</td>
                                <td>{{ employeeCase.status }}</td>
                                <td class="table-right">
                                    <div class='custom-control custom-checkbox'>
                                    <input 
                                    type="checkbox" 
                                    class="custom-control-input" 
                                    :id="'caseSelect' + employeeCase.caseId"
                                    :checked="isCaseSelected(employeeCase.caseId)"
                                    @click="selectCase($event, employeeCase.caseId)">
                                    <label class="custom-control-label" :for="'caseSelect' + employeeCase.caseId"></label>
                                </div>
                                </td>
                            </tr>
                        </template>
                        <template
                            v-else>
                            <tr>
                                <td
                                    id="noCasesMessage"
                                    class="centered"
                                    colspan="7">
                                    No cases found for this employee
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </template>
        </table-results-helper>
        <button
            v-if="caseResults && caseResults.length > 0"
            class="btn btn-primary view-cases-button btn-block"
            :disabled="!selectedCases.length > 0 || isFetchingSummary"            
            @click="getCaseSummary">
            <template v-if="isFetchingSummary">
                <span class="spinner-border spinner-border-sm button-spinner" role="status" aria-hidden="true"></span>
                Loading Summary
            </template>
            <template v-else>
            View Summary
            </template>
        </button>
    </section>
</template>

<script>
import TableResultsHelper from './helpers/TableResultsHelper.vue';

export default {
    components: {
        'table-results-helper': TableResultsHelper,
    },
    props: [
        'caseResults',
        'reportEmployees',
        'selectedCases',
        'isFetchingSummary',
    ],
    data() {
        return {};
    },
    computed: {
        sortedEmployees() {
            const reportEmployees = [...this.reportEmployees];
            return reportEmployees.sort((a,b) => { 
                if (a.name < b.name) { 
                    return -1; 
                }
                if (a.name > b.name) { 
                    return 1; 
                }
                return 0
            });
        },
    },
    methods: {
        getCaseSummary() {
            this.$emit('getCaseSummary');
        },
        isCaseSelected(caseId) {
            return this.selectedCases.includes(caseId);
        },
        employeeCases(employeeId) {
            return this.caseResults.filter(c => c.employeeId == employeeId);
        },
        selectCase($event, caseId) {
            this.$emit('selectCase', $event, caseId);
        },
        selectAllEmployeeCases($event, employeeId) {
            const employeeCases = this.caseResults
                .filter(c => c.employeeId == employeeId)
                .map(c => c.caseId);
            this.$emit('selectAllEmployeeCases', $event, employeeCases);
        },
        isAllCasesSelected(employeeId) {
            const employeeCases = this.caseResults
                .filter(c => c.employeeId == employeeId)
                .map(c => c.caseId);

            if (employeeCases.length <= 0) {
                return false;
            }
            return employeeCases.every(c => this.selectedCases.includes(c));
        },
    },
};
</script>

<style lang="scss" scoped>
  .case-results-container {
      display: flex;
      flex-direction: column;
      margin-bottom: var(--global-gutter-size);
      .view-cases-button {
          margin: 0 auto;
      }
      .centered {
          text-align: center;
      }
  }
  .button-spinner {
      margin-right: 12px;
  }
</style>
